<template>
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <card shadow type="secondary" class="border-0 mb-0">
        <template slot="header">
          <div class="text-center">
            <h2 class="text-dark">Terms of Service</h2>
            <p class="text-muted">Last updated: January 29, 2026</p>
          </div>
        </template>

        <div class="px-lg-4">
          <h4>1. Acceptance of Terms</h4>
          <p>By accessing and using Quran Clip Helper ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.</p>

          <h4>2. Description of Service</h4>
          <p>Quran Clip Helper is a free web-based tool that helps users create video clips featuring Quranic content. The Service includes:</p>
          <ul>
            <li>Helper module for accessing Quranic text, fonts, and translations</li>
            <li>Video Creator with AI-powered ayah detection</li>
            <li>Customizable video overlays and backgrounds</li>
            <li>Word-by-word translation features</li>
          </ul>

          <h4>3. Acceptable Use</h4>
          <p>You agree to use the Service only for:</p>
          <ul>
            <li>Creating Quranic content for educational, religious, and dawah purposes</li>
            <li>Personal, non-commercial use unless otherwise agreed</li>
            <li>Purposes that are lawful and in accordance with Islamic principles</li>
          </ul>
          <p><strong>You agree NOT to:</strong></p>
          <ul>
            <li>Use the Service to create content that misrepresents or distorts Quranic verses</li>
            <li>Upload harmful, malicious, or inappropriate content</li>
            <li>Attempt to overload, disrupt, or abuse the Service</li>
            <li>Circumvent rate limits or security measures</li>
            <li>Use automated tools to scrape or abuse the Service</li>
            <li>Resell or redistribute the Service without permission</li>
          </ul>

          <h4>4. User Content</h4>
          <p>You retain ownership of content you upload (audio, images, videos). By uploading content, you represent that:</p>
          <ul>
            <li>You have the right to use and upload the content</li>
            <li>The content does not infringe on any third-party rights</li>
            <li>The content is appropriate and lawful</li>
          </ul>
          <p>We do not claim ownership of your uploaded content. Uploaded files are processed temporarily and deleted automatically.</p>

          <h4>5. Intellectual Property</h4>
          <p><strong>Quranic Content:</strong> The Quran is the word of Allah and is not subject to copyright. Fonts used are from the King Fahd Complex and other legitimate sources.</p>
          <p><strong>Service:</strong> The Service design, code, and features are proprietary. You may not copy, modify, or distribute the Service without permission.</p>
          <p><strong>Your Videos:</strong> Videos you create using the Service are yours to use, share, and distribute as you see fit, subject to applicable laws.</p>

          <h4>6. Service Limitations</h4>
          <ul>
            <li><strong>Rate Limits:</strong> Users are limited to 5 video exports per hour per IP address</li>
            <li><strong>File Size Limits:</strong> Audio (25MB), Images (10MB), Video backgrounds (50MB)</li>
            <li><strong>Queue Limits:</strong> Maximum 10 jobs in the processing queue</li>
            <li><strong>Availability:</strong> The Service is provided "as is" without guarantees of uptime</li>
          </ul>

          <h4>7. Disclaimer of Warranties</h4>
          <p>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. WE DO NOT GUARANTEE:</p>
          <ul>
            <li>The accuracy of AI-powered ayah detection</li>
            <li>The accuracy of translations (sourced from third-party APIs)</li>
            <li>Uninterrupted or error-free service</li>
            <li>That the Service will meet your specific needs</li>
          </ul>
          <p>Always verify Quranic text and translations for accuracy before public use.</p>

          <h4>8. Limitation of Liability</h4>
          <p>To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service.</p>

          <h4>9. Donations</h4>
          <p>Quran Clip Helper is a free service. Donations are voluntary and help sustain the Service. Donations are non-refundable and do not grant any special rights or privileges.</p>

          <h4>10. Third-Party Services</h4>
          <p>The Service integrates with third-party services (Google, Quran.com, QuranWBW). Your use of these services is subject to their respective terms and policies.</p>

          <h4>11. Modifications to Terms</h4>
          <p>We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the new Terms.</p>

          <h4>12. Termination</h4>
          <p>We reserve the right to suspend or terminate access to the Service for users who violate these Terms or abuse the Service.</p>

          <h4>13. Governing Law</h4>
          <p>These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.</p>

          <h4>14. Contact</h4>
          <p>For questions about these Terms, please contact us at:</p>
          <ul>
            <li>Email: moazelsayedquran@gmail.com</li>
            <li>Instagram: instagram.com/moazquran</li>
          </ul>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
}
</script>
